// AI 모드 멀티턴 스레드 — 순수 상태 전이(테스트 대상). UI(AiModePanel)와 분리.
export const INITIAL_THREAD = { messages: [], conversationId: null, busy: false, error: null };
const THREAD_STORAGE_VERSION = "v2-product-identity";

export function aiThreadStorageKey(query) {
  return `loginhs:ai-thread:${THREAD_STORAGE_VERSION}:${String(query || "")}`;
}

export function threadReducer(state, action) {
  switch (action.type) {
    case "restore":
      return action.thread || INITIAL_THREAD;
    case "reset":
      return INITIAL_THREAD;
    case "start":
      return { messages: [{ role: "user", content: action.q }], conversationId: null, busy: true, error: null };
    case "ask":
      return { ...state, busy: true, error: null,
        messages: [...state.messages, { role: "user", content: action.q }] };
    case "answer":
      return { ...state, busy: false,
        conversationId: action.conversationId != null ? action.conversationId : state.conversationId,
        messages: [...state.messages, {
          role: "assistant", content: action.answer,
          citations: action.citations || [], related: action.related || [], fallback: !!action.fallback,
          reverseValidation: action.reverseValidation || null,
          classifierReverseValidation: action.classifierReverseValidation || null,
          productResearch: action.productResearch || null,
          productConfirmationRequired: !!action.productConfirmationRequired,
          confirmedProductDescription: action.confirmedProductDescription || null,
          selectedFact: action.selectedFact || null,
          selectedCandidateHsk: action.selectedCandidateHsk || null,
          inputAmbiguity: action.inputAmbiguity || [],
          candidateOptions: action.candidateOptions || [],
          webSources: action.webSources || [],
          requestedModel: action.requestedModel || null,
          actualModel: action.actualModel || null,
          providerFallback: !!action.providerFallback,
          modelSucceeded: action.modelSucceeded !== false,
          generationStatus: action.generationStatus || null }] };
    case "error":
      return { ...state, busy: false, error: action.error };
    default:
      return state;
  }
}

// 후속 요청 바디 — 히스토리는 role/content 만(백엔드 계약).
export function followupBody(q, state) {
  return {
    q,
    conversation_id: state.conversationId,
    history: state.messages.map((m) => ({ role: m.role, content: m.content })),
  };
}
